export default "__VITE_ASSET__DZM3Lre___"